import React from 'react'
import './stepper.css'

class Stepper extends React.Component {
	constructor(props) {
        super(props);
        this.state = {
        	percentage: 0
        }
    }
    componentDidMount() {
    	let finalWidth = 0;
    	let perc = this.props && this.props.percentage ? this.props.percentage : 0;
    	let stepper = document.getElementById('stepper');
    	if(stepper) {
	    	let stepperWidth = stepper.offsetWidth;
	    	finalWidth = stepperWidth/100*perc;
	    }
	    this.setState({
            'percentage' : finalWidth
        });
    }
    render() {
        return ( 
            <div id="stepper">
                <div className="filler" style={ { width: this.state.percentage+'px' } }>

                </div>
            </div>
        )
    }
}

export default Stepper


// WEBPACK FOOTER //
// ./src/components/shared/stepper.js